import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getAlgoliaDataQueryId } from 'selectors/algolia2/data'
import { getHasInitialLoad, getHasValidPermissions } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  hasInitialLoad: getHasInitialLoad,
  hasValidPermissions: getHasValidPermissions,
  queryID: getAlgoliaDataQueryId,
})

export type ConnectorProps = {
  hasInitialLoad: boolean
  hasValidPermissions: boolean
  queryID: string
}
export default connect(mapStateToProps)
